import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";


const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
   const [toggle, setToggle] = useState("");
   const onClick = (name) => setToggle(toggle === name ? "" : name);

   const handleSideBarClick = React.useCallback(() => {
      if (onClick2) onClick2();
   }, [onClick2]);

   const handleSideBarClick3 = React.useCallback(() => {
      if (onClick3) onClick3();
   }, [onClick3]);

   return (
      <Fragment>
         <NavHader />
         <SideBar onClick={handleSideBarClick} onClick3={handleSideBarClick3} />
         <Header
            onNote={() => onClick("chatbox")}
            onNotification={() => onClick("notification")}
            onProfile={() => onClick("profile")}
            toggle={toggle}
            title={title}
            onBox={() => onClick("box")}
            onClick={() => ClickToAddEvent()}
         />
      </Fragment>
   );
};

export default JobieNav;
